module.exports = __webpack_public_path__ + "static/media/icon-sent-blk-small.d844049c.svg";